import { render, staticRenderFns } from "./MoneyReceipt.vue?vue&type=template&id=4c4ae504&scoped=true"
import script from "./MoneyReceipt.vue?vue&type=script&lang=js"
export * from "./MoneyReceipt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4ae504",
  null
  
)

export default component.exports